<template>
  <v-stepper
    :value="currentStep"
    flat
    class="wizard-stepper"
  >
    <v-stepper-header>
      <template v-for="(name, idx) in stepNames">
        <v-stepper-step
          :key="`step-${idx}`"
          :step="idx + 1"
          :complete="idx + 1 < currentStep"
        >
          {{ name }}
        </v-stepper-step>
        <v-divider
          v-if="idx < stepNames.length - 1"
          :key="`divider-${idx}`"
        />
      </template>
    </v-stepper-header>
  </v-stepper>
</template>

<script>
export default {
  name: 'WizardStepper',
  props: {
    currentStep: { type: Number, required: true },
    stepNames: { type: Array, required: true },
  },
}
</script>
